module.exports = __webpack_public_path__ + "img/09.a.58b6c180.webp";